import React from "react";
import {Box, ButtonBase, Stack, Typography} from "@mui/material";
import {NavLink, useLocation} from "react-router-dom";
import {useSetAtom} from "jotai";
import {HugeiconsIcon} from "@hugeicons/react";
import {Call02Icon, ChartLineData01Icon, CustomerSupportIcon} from "@hugeicons/core-free-icons";
import {PhoneTabAtom} from "./atoms";
import {useWebrtc} from "../../context/WebrtcContext";
import {CallTimer, isCallLive} from "../../components/webrtc/ActiveCallCard";

export const MOBILE_BOTTOM_NAV_HEIGHT = 84;

const itemSx = (active, live) => ({
  flex: 1, minWidth: 0, px: 0.5, flexDirection: "column", gap: 0.25, height: 52, borderRadius: "18px", textDecoration: "none",
  color: live ? "#1E8A55" : active ? "#4B55C9" : "#8A8AA0",
  bgcolor: live ? "rgba(47, 194, 117, 0.16)" : active ? "rgba(132, 145, 247, 0.14)" : "transparent",
  transition: "background-color .15s ease, color .15s ease",
  "&.Mui-disabled": {opacity: 0.4},
});

// Floating pill navigation on mobile, showing the pages the role may open. 
export const MobileBottomNav = ({basePath, role}) => {
  const {pathname} = useLocation();
  const {status, call} = useWebrtc();
  const live = isCallLive(call);
  const setPhoneTab = useSetAtom(PhoneTabAtom);
  const items = [
    {label: "Dashboard", icon: ChartLineData01Icon, to: basePath, active: pathname === basePath, roles: ["ADMIN", "MANAGER", "AGENT"]},
    {label: "Supervision", icon: CustomerSupportIcon, to: `${basePath}/supervision`, active: pathname.startsWith(`${basePath}/supervision`), roles: ["ADMIN", "MANAGER", "AGENT", "ANNOTATOR"]},
    // the browser phone: greyed out until it is connected (the header's Connect button)
    {label: "Phone", icon: Call02Icon, onClick: () => setPhoneTab("calls"), disabled: status !== "registered", roles: ["ADMIN", "MANAGER", "AGENT"]},
  ].filter(item => item.roles.includes(role));

  return (
    <Box component={"nav"} aria-label={"Agent navigation"} sx={{position: "fixed", left: 16, right: 16, bottom: 20, zIndex: 1100}}>
      <Stack direction={"row"} gap={0.5} sx={{
        p: 0.75, borderRadius: "28px", bgcolor: "#fff", boxShadow: "0 8px 28px rgba(35, 38, 77, 0.14)",
      }}>
        {items.map(({label, icon, to, active, onClick, disabled}) => (
          <ButtonBase
            key={label}
            disabled={disabled}
            {...(to ? {component: NavLink, to} : {onClick})}
            sx={itemSx(Boolean(active), live && label === "Phone")}
          >
            <HugeiconsIcon icon={icon} size={22} strokeWidth={1.5}/>
            <Typography noWrap sx={{maxWidth: "100%", fontSize: 10, fontWeight: 600, lineHeight: 1.2}}>
              {live && label === "Phone" ? <CallTimer startedAt={call.startedAt}/> : label}
            </Typography>
          </ButtonBase>
        ))}
      </Stack>
    </Box>
  );
};
